module.exports = __webpack_public_path__ + "img/2_209.f3102ed9.png";